import React from "react";

import { Badge } from "../../../components/Badge/Badge";
import { sections } from "../../../handlers/enums";

function DSPSection({ data }) {
	return (
		<div>
			{data.section === sections.SUMMARY && (
				<div className="space-y-1.5">
					<p className="text-base text-[#0F172A] leading-5 font-semibold font-inter">Summary</p>
					{data.value.professionalSummary && (
						<p className="text-sm text-gray-700 font-normal font-inter">{data.value.professionalSummary}</p>
					)}
				</div>
			)}

			{data.section === sections.SKILLS && data.value?.length > 0 && (
				<div className="space-y-1.5">
					<p className="text-base text-[#0F172A] leading-5 font-semibold font-inter">Skills</p>
					<div className="flex items-center flex-wrap gap-[6px]">
						{data.value.map((skill, index) => (
							<Badge key={index} className="text-sm text-gray-700 font-medium" variant="secondary">
								{skill}
							</Badge>
						))}
					</div>
				</div>
			)}

			{data.section === sections.EXPERIENCE && data.value?.length > 0 && (
				<div className="space-y-1.5">
					<p className="text-base text-[#0F172A] leading-5 font-semibold font-inter">Work History</p>
					<div className="space-y-6">
						{data.value.map((experience, index) => (
							<div key={index}>
								<div className="flex items-center justify-between">
									<p className="text-sm font-inter font-semibold">{experience.title}</p>
									<p className="text-sm font-inter font-semibold">{`${experience.from} - ${experience.to}`}</p>
								</div>
								<p className="text-sm font-inter font-medium">{experience.company}</p>
								<p className="text-sm text-gray-700 font-normal font-inter">{`${experience.contributions}`}</p>
							</div>
						))}
					</div>
				</div>
			)}

			{data.section === sections.EDUCATION && data.value?.length > 0 && (
				<div className="space-y-1.5">
					<p className="text-base text-[#0F172A] leading-5 font-semibold font-inter">Education</p>
					<div className="space-y-6">
						{data.value.map((education, index) => (
							<div key={index}>
								<div className="flex items-center justify-between">
									<p className="text-sm font-inter font-semibold">
										{education.degree} {education.major}
									</p>
									<p className="text-sm font-inter font-semibold">{education.year}</p>
								</div>
								<p className="text-sm font-inter font-medium">{education.institution}</p>
							</div>
						))}
					</div>
				</div>
			)}

			{data.section === sections.CERTIFICATION && data.value?.length > 0 && (
				<div className="space-y-1.5">
					<p className="text-base text-[#0F172A] leading-5 font-semibold font-inter">Certifications</p>
					<ul className="pl-4 list-disc text-gray-700 text-sm font-normal font-inter">
						{data.value.map((certification, index) => (
							<li key={index}>
								<div className="flex justify-between items-center">
									<span>
										{certification.name} {certification.issuingOrganization && `(${certification.issuingOrganization})`}
									</span>
									<span>{certification.year}</span>
								</div>
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
}

export default DSPSection;
